var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgEnergy = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none",
    viewBox: "0 0 32 32",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "#EDEFF2",
    rx: 8
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M13.523 7.45a.64.64 0 0 0-.189.212c-.031.067-.884 2.273-1.896 4.9C10.1 16.042 9.6 17.381 9.6 17.49a.57.57 0 0 0 .293.472c.126.074.182.076 2.693.086l2.564.01-.021.082-.945 3.819c-1.027 4.156-.979 3.88-.723 4.131.18.178.506.203.703.054.109-.083-.398.7 4.087-6.314 3.695-5.78 3.829-5.995 3.829-6.162a.56.56 0 0 0-.294-.496c-.125-.074-.185-.076-2.335-.087l-2.207-.01 1.096-2.498c1.184-2.698 1.181-2.69 1.024-2.949a.7.7 0 0 0-.193-.193c-.116-.071-.19-.073-2.818-.074h-2.699z",
    clipRule: "evenodd"
  })));
};
export default SvgEnergy;